export default __webpack_public_path__ + "static/media/connect.ee73692e.png";